import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import "../styles/Footer.sass"
import prose from '../../../../assets/prose'
import headshot from '../../../../images/headshot-grayscale.png'
import AboutTheAuthor from '../../articles/components/AboutTheAuthor'
import Authors from '../../../shared/articles/constants/AuthorConstants'
import Resources from '../../../home/components/Resources'

const MenuList = props => {
  return (
    <div className="menu-list">
      <div className="menu-list--title">{props.title}</div>
      {props.items.map((item, index) => {
        if (item.email) {
          return (
            <a key={index} href="mailto:khalil@khalilstemmler.com">
              {item.name}
            </a>
          )
        } else if (item.external) {
          return (
            <a target="blank" key={index} href={item.url}>
              {item.name}
            </a>
          )
        } else
          return (
            <Link style={{ textDecoration: 'none' }} to={item.url} key={index}>
              {item.name}
            </Link>
          )
      })}
    </div>
  )
}

const Menu = () => {
  return (
    <div className="menu-list--container">
      <MenuList
        title={'Menu'}
        items={[
          { name: 'About', url: '/about' },
          { name: 'Articles', url: '/articles' },
          { name: 'Community', url: 'https://discord.gg/TnqMR2P2rV' },
          { name: 'Resources', url: '/resources' },
          { name: 'Wiki', url: '/wiki' }
        ]}
      />
      <MenuList
        title={'Contact'}
        items={[
          {
            name: 'Email',
            url: 'khalil@khalilstemmler.com',
            email: true,
          },
          {
            name: '@khalilstemmler',
            url: 'https://twitter.com/khalilstemmler',
            external: true,
          },
        ]}
      />

      <MenuList
        title={'Social'}
        items={[
          {
            name: 'GitHub',
            url: 'https://github.com/stemmlerjs',
            external: true,
          },
          {
            name: 'Twitter',
            url: 'https://twitter.com/khalilstemmler',
            external: true,
          },
          {
            name: 'Instagram',
            url: 'https://instagram.com/khalilstemmler',
            external: true,
          },
          {
            name: 'LinkedIn',
            url: 'https://www.linkedin.com/in/khalilstemmler/',
            external: true,
          },
        ]}
      />
    </div>
  )
}

const FooterBanner = () => {
  const currentYear = new Date().getFullYear()
  
  return (
    <div className="footer--banner flex align-center justify-center wrap">© khalilstemmler • {currentYear}</div>
  )
}


const Footer = ({ pageType }) => (
  <>
    <footer className="footer">
      <div className='footer-container'>
        {/* <div className="footer--description">{ prose.main.description }</div> */}
      <h1>Who is Khalil Stemmler?</h1>
      <AboutTheAuthor {...Authors.khalil}/>
      {pageType === 'article' || pageType === 'articles' ? ( <Resources/> ): ''}
      {pageType === 'article' || pageType === 'articles' ?  '' : <Menu/> }
      </div>
    </footer>
    <FooterBanner/>
  </>
)

export default Footer;
